'use client'; // Error components must be Client Components
import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { IosAddIcon, IosArrowToShareIcon, IosShareIcon } from '../../icons';

import Step from './parts/Step';
import { BaseWrapper, Title } from './Shared.styles';
import { SkipPWA } from './SkipPWA';

export const AppleDeviceCTA = () => {
	const { $t } = useIntl();

	return (
		<S.Wrapper>
			<S.Content>
				<SkipPWA />
				<div>
					<Title>{$t('pwa.instructions.ios.title')}</Title>
					<span>{$t('pwa.instructions.ios.description')}</span>
				</div>
				<S.Steps>
					<Step
						content={$t('pwa.instructions.ios.step1')}
						Icon={IosShareIcon}
						title={$t('pwa.instructions.step_number', { number: '1' })}
					/>
					<Step
						content={$t('pwa.instructions.ios.step2')}
						Icon={IosAddIcon}
						title={$t('pwa.instructions.step_number', { number: '2' })}
					/>
				</S.Steps>
				<S.Arrow />
			</S.Content>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled(BaseWrapper)`
		justify-content: space-between;
		align-items: flex-start;
	`;
	export const Content = styled.div`
		display: flex;
		padding: ${({ theme }) => `${theme.spacings.xxlarge} ${theme.spacings.small} ${theme.spacings.small}`};
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		align-self: stretch;
		text-align: center;
		height: 70vh;
	`;
	export const Steps = styled.div`
		display: flex;
		padding: ${({ theme }) => `${theme.spacings.small} 0`};
		justify-content: flex-start;
		text-align: left;
	`;
	export const Arrow = styled(IosArrowToShareIcon)`
		position: absolute;
		bottom: ${({ theme }) => theme.spacings.small};
		right: 58%;
		transform: translateX(50%);
	`;
}
